import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import CategoryList from "../../features/manageCategories/categoryList";
import CategoryTopbar from "../../features/manageCategories/topbar";
import SearchBar from "../../components/SearchBar";
import { Box, Button, Tab, Tabs } from "@mui/material";
import AddCategory from "../../Modals/addCategory";
import { useState } from "react";
import CustomPagination from "../../components/CustomPagination";
import FilterMenu from "../../components/filterMenu";
import GroupList from "./groupTable";
import AddGroup from "../../Modals/addGroup";


interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}


const ManageGroups = () => {

  const navigate = useNavigate();
      const [open, setOpen] = useState(false);
      const handleCloseModal = () => {
        setOpen(false);
      };

       const [valueTabs1, setValueTabs1] = useState(0);
        const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
          setValueTabs1(newValue);
        };

  return (
    <>
    <MainContainer>
      <div className="main_title d_flex">
        <h1>Manage Groups</h1>
    <div className="right_s">
      <SearchBar searchTerm={""} placeholder={"Search "} />
      <Button className="btn btn_primary" onClick={() => setOpen(true)}>+ Add New Group</Button>
    <FilterMenu />

    </div>
      </div>
      
      <div className="cards table_cards v2">
    <GroupList />
      </div>
      <CustomPagination />
    </MainContainer>
     <AddGroup open={open} onClose={handleCloseModal} setOpen={setOpen} />
     </>
  );
};

export default ManageGroups;
